import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EventBusService } from 'framework/eventbus.service';
import { TranslateService } from 'framework/i18n';
import { UtilService } from 'framework/utils/util.service';
import { EmploymentService } from '../employment.service';
import * as dateUtils from './../../../framework/utils/date.utils';
import { Observable } from 'rxjs';
import { ClipboardService } from 'app/clipboard/clipboard.service';
import { progressBarStatus } from 'framework/progressbar.service';
import { StatusbarService } from 'app/status-bar/status-bar.service';
import { SharedService } from 'app/shared/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { recordidService } from '../employment-recordid.service';
import { arrowService } from 'framework/arrow.service';
import { EmploymentConfig } from '../employment.config';
import { ViewChild } from '@angular/core';
import { AdditionalEducationKnockoutComponent } from './additional-education-knockout/additional-education-knockout.component';
import { AdditionalEducationReconfirmComponent } from './additional-education-reconfirm/additional-education-reconfirm.component';

declare var $: any;
@Component({
  selector: 'additional-education',
  templateUrl: './additional-education.component.html',
  styleUrls: ['./additional-education.component.css']
})
export class AdditionalEducationComponent implements OnInit {
  additionalEducationForm: FormGroup;
  isFormInit: boolean = false;
  sliderIndex: number;
  currentSlide;
  currentSlideWithDirection;
  additionalEducationSteps: any = [
    'additionaleducationknockout',
    'additionaleducationdetails',
    'additionaleducationreconfirm'
  ];
  isFromClipboard: boolean = false;
  isAjaxCallProccess: boolean = false;
  recordId: any = null;
  currentRow: any;
  dateOptions: any;
  
  @Input() configOptions: any;
  @Input() isEmploymentGapInDaysEnabled: boolean;
  
  @Input() isReviewEdit: boolean;
  @Input() isReview: boolean;
  @Input() isReviewAdd: boolean;
  @Input() zipCodeError: boolean;
  @Input() inputStoreAdditionalEducationData: any;
  
  @Output() onAdditionalEducationKnockout: EventEmitter<any> = new EventEmitter<any>();
  fromServerError: boolean;
  ErrorCode: string;
  isSameCountry: any;
  nextURL: string;
  nextdisplayname: any;
  PARENT_STAGE_STEP_CONFIG: { STAGE_ID: any; STEP_ID: any; STEP_INDEX: any; };
  static STAGE_ID: string = 'employment-data-v1';
  static STEP_ID: string = 'additional-education-step-v1';
  static STEP_INDEX: number = 0;
  defaultConfig: Object = {};
  querySub: any;
  cbOptions: any;
  fullData: any;
  isDbRecordPresent: boolean = false;
  options: any[] = [];
  getDataLength: any;
  reviewSaveExit: boolean;
  backarrow: boolean = false;
  dateConfigs: any[] = [];
  
  @ViewChild(AdditionalEducationKnockoutComponent)
  additionalEducationKnockoutComponent: AdditionalEducationKnockoutComponent;
  @ViewChild(AdditionalEducationReconfirmComponent)
  additionalEducationReconfirmComponent: AdditionalEducationReconfirmComponent;

  constructor(private _translate: TranslateService,
              private _formBuilder: FormBuilder,
              public _eventBus: EventBusService,
              private _utilService: UtilService,
              private _es: EmploymentService,
              private _cs: ClipboardService,
              private _progressbarStatus: progressBarStatus,
              private _statusBar: StatusbarService,
              private _sharedService: SharedService,
              private _route: Router,
              private _recordidservice: recordidService,
              private _arrowservice: arrowService,
              private _activatedRoute: ActivatedRoute) {
  }
  
  ngOnInit() {
    this.PARENT_STAGE_STEP_CONFIG = {
      STAGE_ID: AdditionalEducationComponent.STAGE_ID,
      STEP_ID: AdditionalEducationComponent.STEP_ID,
      STEP_INDEX: AdditionalEducationComponent.STEP_INDEX
    };
    
    this._recordidservice.makeAdditionalEducationRecordidEmpty();
    
    this.isReview = false;
    this.isReviewEdit = false;
    this.isReviewAdd = false;
    this.nextURL = this._es.getNextURL();
    this.nextdisplayname = this._es.getNextDisplayName();
    
    let componenetarray = ['knockout', 'details', 'reconfirm'];
    this._arrowservice.setarrowarray(componenetarray);
    
    let defaultCountryOptions = EmploymentConfig.defaultCountryOptions();
    this.defaultConfig['countryOptions'] = {
      'country': defaultCountryOptions['defaultCountry'],
      'countryShortName': defaultCountryOptions['defaultCountryShortName']
    };
    this.options.push(this.defaultConfig);
    
    this.querySub = this._activatedRoute.queryParams.subscribe(params => {
      if (params['from'] === 'review') {
        this.isFromClipboard = true;
        this.isReview = true;
        
        this.cbOptions['isFromClipboard'] = this.isFromClipboard;
      }
      
      if (this.isReview) {
        if (params['id']) {
          this.isReviewEdit = true;
          this.isReviewAdd = false;
          this.recordId = params['id'];
        } else {
          this.isReviewEdit = false;
          this.isReviewAdd = true;
          this.recordId = null;
        }
      }
    });
    
    if (this.isReviewEdit) {
      this.getDataById(this.recordId)
    } else {
      this.getData();
    }
  }
  
  getData() {
    this.fullData = this.inputStoreAdditionalEducationData;
    this.isDbRecordPresent = true;
    
    this.updateServerData(this.fullData);
    
    this.getById(this.fullData);
  }
  
  getDataById(recordId) {
    // Filter the data by recordId and return the value
    let editData = this.inputStoreAdditionalEducationData.filter(item => {
      return item['id'] === recordId;
    });
    
    if (editData.length === 0) {
      // If no data found, return empty array
      this.isDbRecordPresent = false;
      return [];
    } else if (editData.length > 1) {
      this.isDbRecordPresent = true;
      
      this.updateServerDataById(editData);
      
      this.initEditAdditionalEducationForm(editData);
    }
  }
  
  private updateServerData(response) {
    let data = response;
    let additionalEducationDataList = data['employment-data-list'];
    this._es.setAdditionalEducationServerData(additionalEducationDataList);
  }
  
  private getById(data) {
    let res = data['employment-data-list'];
    let currentPosition = !!data && data['state'] ? data['state'] : {};
    this.getDataLength = res.length;
    let saveExitReviewAdd = currentPosition['stage_status'];
    
    if (saveExitReviewAdd === "REVIEW_EDIT" || saveExitReviewAdd === "REVIEW_ADD") {
      this.isReview = true;
      this.reviewSaveExit = true;
      this.cbOptions['isFromClipboard'] = this.reviewSaveExit;

      if (saveExitReviewAdd === "REVIEW_EDIT") {
        this.isReviewEdit = true;
        let currentId = currentPosition['current_iteration'];
        let currentItemArr = res.filter(obj => {
          return obj['id'] == currentId;
        });

        currentPosition['current_iteration'] = "0";
        
        this.initExistingAdditionalEducationForm(currentItemArr, currentPosition)
      }  else if (saveExitReviewAdd === "REVIEW_ADD") {
        this.isReviewAdd = true;
        this._recordidservice.setprofileBuilderbutton(this.isReviewAdd)
        let datalength = res.length;
        let currentItemArr = [];
        let currentItemobj = {}
        currentItemobj = res[datalength - 1];
        currentItemArr.push(currentItemobj);
        currentPosition['current_iteration'] = "0";
        
        this.initExistingAdditionalEducationForm(currentItemArr, currentPosition)
      }
      let profilebilderbutton = false;
      this._recordidservice.setprofileBuilderbutton(profilebilderbutton);
    } else {
      if (res.length > 0) {
        if (!this.isFromClipboard) {
          this.initExistingAdditionalEducationForm(res, currentPosition);
        } else {
          if (this.isReviewAdd) {
            this.initAddNewAdditionalEducationForm(res)
          }
        }
      } else {
        let res = data['employment-data-list'];
        
        if (this.isReviewAdd) {
          this.initAddNewAdditionalEducationForm(res);
        } else {
          this.initDetails();
        }
      }
    }
  }
  
  private initEditAdditionalEducationForm(data) {
    let currentItem = {};
    let options = null;
    let row = "0";
    this.recordId = data.id;
    
    this._recordidservice.makeAdditionalEducationRecordidEmpty();
    this._recordidservice.setAdditionalEducationRecordid(row, this.recordId);
    
    currentItem['country'] = data.country;
    currentItem['country_code'] = data.country_code;
    currentItem['country_name'] = data.country_name;
    currentItem['state_name'] = data.state_name;
    currentItem['state_code'] = data.state_code;
    currentItem['city'] = data.city;
    currentItem['zip'] = data.zip;
    currentItem['jobFrom'] = data.from_date;
    currentItem['jobTo'] = data.to_date;
    
    let countryConfig: Object = {};
    countryConfig['countryOptions'] = {
      'country': data.country_name,
      'countryShortName': data.country
    };
    
    this.options.splice(0, 1);
    this.options.push(countryConfig);
    
    this.sliderIndex = 1;
    this.setSlider(this.sliderIndex, 0);
    this.initAdditionalEducationForm(currentItem);
  }

  private initExistingAdditionalEducationForm(res, currentPosition) {
    let datalength = res.length;
    let row = (currentPosition.current_iteration === undefined) ? "0" : currentPosition.current_iteration;
    
    if (!this.isFromClipboard)
      this.currentRow = row;
    
    let sliderIndexobject = this._recordidservice.getAdditionalEducationSliderIndexValue(currentPosition.current_sub_step);
    
    if (sliderIndexobject !== undefined) {
      this.sliderIndex = sliderIndexobject['step_index'];
    } else {
      this.sliderIndex = 0;
    }

    this.setSlider(this.sliderIndex, row);
    
    if (datalength > 0) {
      this.options.splice(0, 1);
    }
    
    this._recordidservice.makeAdditionalEducationRecordidEmpty();

    for (let i = 0; i < datalength; i++) {
      let currentitem = {}
      let options = null;
      currentitem['country'] = res[i].country;
      currentitem['country_name'] = res[i].country_name;
      currentitem['state_name'] = res[i].state_name;
      currentitem['state_code'] = res[i].state_code;
      currentitem['city'] = res[i].city;
      currentitem['zip'] = res[i].zip;
      // currentitem['jobFrom'] = res[i].from_date;
      // currentitem['jobTo'] = res[i].to_date;

      let countryConfig: Object = {};
      countryConfig['countryOptions'] = {
        'country': res[i].country_name,
        'countryShortName': res[i].country
      };

      countryConfig['stateOptions'] = {
        'stateCode': res[i].state_code
      };

      this.options.push(countryConfig);

      if (!!res[i]['start-date']) {
        currentitem['jobFrom'] = this._es.getFormatedDate(res[i]['start-date'], this.getDateFormat());
      }

      if (!!res[i]['end-date']) {
        currentitem['jobTo'] = this._es.getFormatedDate(res[i]['end-date'], this.getDateFormat());
      }

      if (!!currentitem['jobFrom'] && !!currentitem['jobTo']) {
        let dateOptions = {};
        let fromFormattedDate;
        fromFormattedDate = (!!currentitem && !!currentitem['jobFrom']) ? this._es.fromDateOptions(currentitem['jobFrom']) : this._es.fromDateOptions();
        dateOptions['from'] = fromFormattedDate;
        
        let toFormattedDate;
        toFormattedDate = (!!currentitem && !!currentitem['jobTo']) ? this._es.toDateOptions(currentitem['jobTo']) : this._es.toDateOptions();
        dateOptions['to'] = toFormattedDate;

        if (!!this.dateConfigs && !!this.dateConfigs[i]) {
          this.dateConfigs[i] = dateOptions;
        } else {
          this.dateConfigs.push(dateOptions);
        }
      }
      
      if (i == 0) {
        this.initAdditionalEducationForm(currentitem);
      } else {
        // this.options.push(this.defaultConfig);
        this.addAdditionalEducationForm(currentitem);
      }
      
      let recordid = res[i].id;
      this._recordidservice.setAdditionalEducationRecordid(i, recordid);
    }
  }
  
  getDateFormat() {
    if (this.isEmploymentGapInDaysEnabled) {
      return 'MMMM dd,YYYY';
    } else {
      return 'MMMM YYYY';
    }
  }
  
  addAdditionalEducationForm(options) {
    const control = <FormArray>this.additionalEducationForm.controls['additionalEducationSubForm'];
    control.push(this.initForm(options));
  }
  
  private updateServerDataById(response) {
    let body = [];
    body[0] = response;
    
    this._es.setAdditionalEducationServerData(body);
  }
  
  private initDetails() {
    this.sliderIndex = 0;
    this.currentRow = '0';
    let direction = '_right';
    this.setSlider(this.sliderIndex, 0);
    this.currentSlideWithDirection = this.currentSlide + direction;
    
    let opts = {};
    opts['from'] = '';
    opts['to'] = '';
    this.dateConfigs[0] = opts;
    
    if (!this.isFromClipboard) {
      let options = null;
      
      this.initAdditionalEducationForm(options);
    }
  }
  
  private setSlider(index, i?, j?): void {
    let seprator: string = '_';
    this.currentSlide = this.additionalEducationSteps[index]; //componentName,seprator,index(s)
    
    if (i > -1) {
      this.currentSlide += `${seprator}${i}`; // componentName,seprator,index(s)
    }
    if (j > -1) {
      this.currentSlide += `${seprator}${j}`; // componentName,seprator,index(s)
    }
  }

  private initAddNewAdditionalEducationForm(res) {
    this._recordidservice.makeRecordidEmpty();
    this.sliderIndex = 1;
    this.setSlider(this.sliderIndex, 0);
    let options = null;
    
    let opts = {};
    opts['from'] = '';
    opts['to'] = '';
    this.dateConfigs[0] = opts;
    
    this.initAdditionalEducationForm(options);
  }
  
  private initAdditionalEducationForm(option) {
    let options = option;
    
    this.additionalEducationForm = this._formBuilder.group({
      additionalEducationSubForm: this._formBuilder.array([
        this.initForm(options)
      ])
    });
    
    this.isFormInit = true;
  }
  
  initForm(options) {
    let jobFrom = '';
    let jobTo = '';
    let countryName = '';
    let countryCode = '';
    let state = '';
    let stateShortName = '';
    let city = '';
    let zip = '';
    
    if (options) {
      if (!!options['jobFrom']) {
        jobFrom = options['jobFrom'];
      }
      
      if (!!options['jobTo']) {
        jobTo = options['jobTo'];
      } 
      
      if (!!options['country_name']) {
        countryName = options['country_name'];
      }
      
      if (!!options['country']) {
        countryCode = options['country'];
      }
    
      if(!!options['state_name']) {
        state = options['state_name'];
      }
      
      if (!!options['state_code']) {
        stateShortName = options['state_code'];
      }
      
      if (!!options['city']) {
        city = options['city'];
      }
      
      if (!!options['zip']) {
        zip = options['zip'];
      }
    }
    
    let formControls = {
      jobFrom: [jobFrom, Validators.required],
      jobTo: [jobTo, Validators.required],
      countryName: [countryName, Validators.required],
      countryCode: [countryCode],
      stateName: [state, Validators.required],
      stateCode: [stateShortName],
      city: [city, Validators.required],
      zipCode: [zip, Validators.required]
    };
    
    return this._formBuilder.group(formControls);
  }

  disableEnterButton(event) {
    if (event.target.tagName == 'TEXTAREA') {
      return true;
    }
    var x = event.keyCode;
    if (x == 13)
      return false;
  }
  
  empAdditionalEducationKnockout(obj) {
    if (obj['isAdditionalEducationAgreed'] === true) {
      let direction = "_right";
      this.sliderIndex += 1;
      this.setSlider(this.sliderIndex, 0);
      this.currentSlideWithDirection = this.currentSlide + direction;
      
      $('#empWaitModal').modal('hide');
    } else {
      if (this.backarrow) {
        this.deleteOtherRecords();
        
        this.goToNextStage(obj);
      } else {
        this.goToNextStage(obj);
      }
    }
  }
  
  private deleteOtherRecords() {
    const recorddata = this._recordidservice.getAllAdditionalEducationRecordid();
    const currentslide = this.currentSlide;
    const currentiteration = Number(currentslide.substring(currentslide.indexOf("_") + 1));
    let slideName = this.currentSlide.substring(0, this.currentSlide.indexOf("_"));
    
    // If currentiteration is 0, delete all records
    if (currentiteration === 0 && slideName === 'additionaleducationknockout') {
      for (let i = 0; i < recorddata.length; i++) {
        const id = recorddata[i];
        if (id != null) {
          this._es.deleteData(id).subscribe(
            () => {},
            error => {
              console.log('Not Deleted');
            }
          );
        }
      }
    } else {
      // Delete records with index greater than currentiteration
      for (let i = currentiteration + 1; i < recorddata.length; i++) {
        const id = recorddata[i];
        if (id != null) {
          this._es.deleteData(id).subscribe(
            () => {},
            error => {
              console.log('Not Deleted');
            }
          );
        }
      }
    }
  }
  
  goToNextStage(item?) {
    let employmentDataItem = {};
    
    // employmentDataItem['state'] = {};

    employmentDataItem['stage_status'] = 'COMPLETED';
    employmentDataItem['current_stage'] = item['COMPONENT_STATE']['name'];
    employmentDataItem['current_step'] = item['COMPONENT_STATE']['step'];
    employmentDataItem['current_step_index'] = item['COMPONENT_STATE']['stepIndex'];
    employmentDataItem['current_sub_step'] = item['COMPONENT_STATE']['subStep'];
    employmentDataItem['current_sub_step_index'] = item['COMPONENT_STATE']['subStepIndex'];
    employmentDataItem['current_iteration'] = '0';
    employmentDataItem['step_status'] = item['COMPONENT_STATE']['status'];
    employmentDataItem['current_status'] = item['COMPONENT_STATE']['status'];
    
    this.goToNextStageUpdatePayload(employmentDataItem);
  }
  
  goToNextStageUpdatePayload(body) {
    this._es.putStateUpdate(body).subscribe(response => {
      this.routeToNextStage();
    }, error => {
      $('#empWaitModal').modal('hide');
      console.log(error);
    });
  }
  
  private routeToNextStage() {
    this._progressbarStatus.setEmployement('true');
    this._progressbarStatus.createEmployeementProgressbar(this.nextdisplayname);
    let flagstatus = this._statusBar.getCompletedMenustatus('employment-data-v1');
    
    if (!flagstatus) {
      this._statusBar.setstatusEmployement('employment-data-v1');
      let statusBarobject = this._statusBar.getStatusBarValue('employmentStatus');
      let remainingSection = statusBarobject['remainingsection'];
      let percentage = statusBarobject['percentage'];
      let remainingTime = statusBarobject['timeremaining'];
      let completedMenu = statusBarobject['completedMenu'];
      this._sharedService.setStatusBar(remainingSection, percentage, remainingTime, completedMenu, this._eventBus);
    }

    this.nextURL = this._es.getNextURL();
    $('#empWaitModal').modal('hide');
    
    if (!!this.nextURL) {
      this._route.navigate([this.nextURL]);
      $('.responsive').slick('next');
    }
  }
  
  empAdditionalEducationDetails(obj) {
    $('#empWaitModal').modal('show');
    
    if (!this.isAjaxCallProccess) {
      let i: number = this.currentRow = obj['indexDetail']['row'];
      let currentRecordId = this._recordidservice.getAdditionalEducationRecordid(i);
    
      if (currentRecordId != undefined || currentRecordId != null) {
        this.recordId = currentRecordId;
      }
      
      obj['service_action'] = 'PERSIST';
      let employmentDataItem = {};
      let newJob:{} = {};
      
      this.formPayload(employmentDataItem, obj, newJob);
      this.saveJob(obj, employmentDataItem);
    }
  }
  
  empAdditionalEducationDetailsSwipe(obj) {
    if (this.currentRow !== 0 || this.currentRow !== "0") {
      this.currentRow = this.currentRow - 1;
    }
    
    // Add check sliderIndex should not be less than 0
    if (this.sliderIndex > 0) {
      this.sliderIndex -= 1;
    }
    
    let current = this.currentSlide;
    let direction = "_left"
    let splitcurrentslideindex = current.substring(current.indexOf("_") + 1);
    let previousindex = splitcurrentslideindex - 1;
    
    if (this.currentSlide == 'additionaleducationdetails_0') {
      this.currentSlide = 'additionaleducationknockout_0'
      this.currentSlideWithDirection = this.currentSlide + direction;
      this.additionalEducationKnockoutComponent.isKnockoutEnabled();
    } else {
      this.currentSlide = 'additionaleducationreconfirm' + '_' + previousindex;
      this.currentSlideWithDirection = this.currentSlide + direction;
      this.additionalEducationReconfirmComponent.shouldEnableReconfirm(previousindex);
    }
    
    this.handleMakeServerValidator({ control: 'countryName', flag: false });
    
    this.backarrow = true;
  }
  
  private formPayload(employmentDataItem, obj, newJob?): void {
    employmentDataItem['state'] = {};
    
    if (!!this.recordId && !!newJob) {
      newJob['id'] = this.recordId;
    }
    
    employmentDataItem['service_action'] = obj['service_action'] || 'PERSIST';

    if (obj['zipCode'] && obj['zipCode'].length > 0) {
      if (newJob) {
        newJob['zipCode'] = obj['zipCode'];
      }
      employmentDataItem['zip'] = obj['zipCode'];
    }

    if (obj['jobFrom'] && obj['jobFrom'].length > 0) {
      if (newJob) {
        newJob['jobFrom'] = obj['jobFrom'];
      }

      employmentDataItem['start-date'] = this._es.getDateToTs(obj['jobFrom']);
      employmentDataItem['from_date'] = dateUtils.getDateFormatYYYYMMDD(employmentDataItem['start-date']);
    }

    if (obj['jobTo'] && obj['jobTo'].length > 0) {
      if (newJob) {
        newJob['jobTo'] = obj['jobTo'];
      }
      
      employmentDataItem['end-date'] = this._es.getDateToTs(obj['jobTo']);
      employmentDataItem['to_date'] = dateUtils.getDateFormatYYYYMMDD(employmentDataItem['end-date']);
    }
    
    if (obj['countryName'] && obj['countryName'].length > 0) {
      if (newJob) {
        newJob['countryName'] = obj['countryName'];
        newJob['countryCode'] = obj['countryCode'];
      }
      
      employmentDataItem['country'] = obj['countryCode'];
      employmentDataItem['country_name'] = obj['countryName'];
    }

    if (obj['city'] && obj['city'].length > 0) {
      if (newJob) {
        newJob['city'] = obj['city'];
      }
      employmentDataItem['city'] = obj['city'];
    }

    if (obj['stateName'] && obj['stateName'].length > 0) {
      if (newJob) {
        newJob['stateName'] = obj['stateName'];
        newJob['stateCode'] = obj['stateCode'];
      }
      employmentDataItem['state_code'] = obj['stateCode'];
      employmentDataItem['state_name'] = obj['stateName'];
    }

    if (obj['type'] && obj['type'].length > 0) {
      if (newJob) {
        newJob['type'] = obj['type'];
      }
      employmentDataItem['type'] = obj['type'];
    }
    
    if (obj['is_collect_education'] !== undefined) {
      employmentDataItem['is_collect_education'] = obj['is_collect_education'];
    }

    if (!!obj['COMPONENT_STATE']) {
      employmentDataItem['state']['stage_status'] = 'PENDING';
      employmentDataItem['state']['current_stage'] = obj['COMPONENT_STATE']['name'];
      employmentDataItem['state']['current_step'] = obj['COMPONENT_STATE']['step'];
      employmentDataItem['state']['current_step_index'] = obj['COMPONENT_STATE']['stepIndex'];
      employmentDataItem['state']['current_sub_step'] = obj['COMPONENT_STATE']['subStep'];
      employmentDataItem['state']['current_sub_step_index'] = obj['COMPONENT_STATE']['subStepIndex'];
      employmentDataItem['state']['current_iteration'] = obj['COMPONENT_STATE']['iteration'];
      employmentDataItem['state']['step_status'] = obj['COMPONENT_STATE']['status'];
      employmentDataItem['state']['current_status'] = obj['COMPONENT_STATE']['status'];
    }

    if (this.recordId) {
      employmentDataItem['id'] = this.recordId;
    }
  }
  
  private saveJob(obj, item) {
    this.zipCodeError = false;
    
    if (!this.isAjaxCallProccess) {
      this.isAjaxCallProccess = true;
      
      let body = {
        'employment-data-list': []
      };
      body['employment-data-list'].push(item);
      
      let that = this;
      
      this._es.save(body).subscribe(response => {
        if (response) {
          let serverDataLen = this._es.getAdditionalEducationServerData().length;
          // Set this.backarrow = false only if the currentRow is same as the serverDataLen
          let compArr = this.currentSlide.split("_");
          let row = compArr[1];
          
          // Add record only if it does not exists in the recordid service
          if (!this._recordidservice.getAdditionalEducationRecordid(row)) {
            this._recordidservice.setAdditionalEducationRecordid(row, response['employment-data-list'][0]['id']);
          }
          
          // Set backarrow = false if currentRow is the last record in recordid service
          const allRecordIds = this._recordidservice.getAllAdditionalEducationRecordid();
          if (this.currentRow === allRecordIds.length - 1) {
            this.backarrow = false;
          }
          
          if (allRecordIds.length > 0 && (allRecordIds.length - 1 !== Number(row))) {
            this.additionalEducationReconfirmComponent.shouldEnableReconfirm(row);
          }
          
          let empDataList = body['employment-data-list'][0];
          let empDataState = empDataList['state'];
          this.isAjaxCallProccess = false;
          
          let serverEmpRes = response['employment-data-list'][0];
          
          if (empDataState['current_status'] === 'COMPLETED') {
            this.makeServerValidator('city', false, serverEmpRes);
            this.makeServerValidator('stateName', false, serverEmpRes);
            this.makeServerValidator('countryName', false, serverEmpRes);
          }
          
          this.afterAdditionalEducationSaveSuccess(obj, serverEmpRes);
          
          $('#empWaitModal').modal('hide');
          return;
        } else {
          this.isAjaxCallProccess = false;
          $('#empWaitModal').modal('hide');
          return;
        }
      }, error => {
        if (error === 'EMPCITY') {
          this.makeServerValidator('city', true);
          if (error !== 'EMPSTATE') {
            this.makeServerValidator('stateName', false);
          }
        } else if (error === 'EMPSTATE') {
          if (error !== 'EMPCITY') {
            this.makeServerValidator('city', false);
          }
          this.makeServerValidator('stateName', true);
        } else if (error === 'EMPZIP' || error === 'EMPERROR') {
          this.zipCodeError = true;
          this.makeServerValidator('zipCode', true);
        } else if (error === 'EMPCOUNTRY') {
          this.makeServerValidator('countryName', true);
        } else if (error === 'EMPINVALIDISDCODE' || error === 'EMPINVALIDPHONENUMBER' || error === 'EMPINVALIDISDCODE EMPINVALIDPHONENUMBER') {
          let random = this._utilService.getCryptoRandom();
          this.ErrorCode = error + '_' + random;
        }
        this.isAjaxCallProccess = false;
        $('#empWaitModal').modal('hide');
        
        return;
      });
    }
  }
  
  afterAdditionalEducationSaveSuccess(dataState, obj) {
    this._es.afterSaveUpdateAdditionalEducationServerData(obj);
    
    let direction = "_right";
    this.sliderIndex += 1;
    this.setSlider(this.sliderIndex, this.currentRow);
    this.currentSlideWithDirection = this.currentSlide + direction;
  }
  
  private makeServerValidator(control, flag, obj?) {
    const subFormArray = <FormArray>this.additionalEducationForm.controls['additionalEducationSubForm'];
    let subFormArrayLength = subFormArray.length;
    let currentSlideArr = this.currentSlide.split('_');
    let currentRow = currentSlideArr[currentSlideArr.length - 1];
    const subFormGroup = <FormGroup>subFormArray.controls[currentRow];
    
    if (!!obj && !!obj['country']) {
      if (subFormGroup.contains('countryCode')) {
        subFormGroup.controls['countryCode'].setValue(obj['country']);
      }
    }

    if (!!obj && !!obj['state_code']) {
      if (subFormGroup.contains('stateCode')) {
        subFormGroup.controls['stateCode'].setValue(obj['state_code']);
      }
    }

    this.fromServerError = flag;
    
    if (!!subFormGroup && subFormGroup.controls[control] !== undefined) {
      subFormGroup.controls[control].clearValidators();
      subFormGroup.controls[control].setValidators(Validators.compose([Validators.required, this.serverValidator.bind(this)]));
      subFormGroup.controls[control].updateValueAndValidity();
    }
  }
  
  private serverValidator(control: FormControl): { [s: string]: boolean } {
    if (this.fromServerError) {
      return { serverError: true };
    } else {
      return null;
    }
  }
  
  handleMakeServerValidator(event: any): void {
    this.zipCodeError = false;
    this.makeServerValidator(event.control, event.flag);
  }
  
  empAdditionalEducationReconfirm(obj) {
    if (obj['isAdditionalEducationReconfirm'] === true) {
      this.currentRow += 1;
      this.recordId = null;
      
      let config = {};
      let countryOptions = {};
      
      countryOptions['country'] = '';
      countryOptions['countryShortName'] = obj['countryShortCode'];
      
      config['countryOptions'] = countryOptions;
      this.options.push(config);
      
      let serverData = this._es.getAdditionalEducationServerData();

      if (serverData && serverData[this.currentRow]) {
        this.recordId = serverData[this.currentRow]['id'];
        
        this.sliderIndex = EmploymentConfig.additionalEducationSubStepIndexMapping['details']['subStepIndex'];
        this.setSlider(this.sliderIndex, this.currentRow);
      } else {
        let opts = {};
        opts['from'] = '';
        opts['to'] = '';
        this.dateConfigs[this.currentRow] = opts;
        
        this.addAdditionalEducationForm(null);
        
        this.sliderIndex = EmploymentConfig.additionalEducationSubStepIndexMapping['details']['subStepIndex'];
        let direction = '_right';
        this.setSlider(this.sliderIndex, this.currentRow);
        this.currentSlideWithDirection = this.currentSlide + direction;
      }
    } else {
      if (this.backarrow || this.currentRow < this.getDataLength) {
        this.deleteOtherRecords();
        
        this.goToNextStage(obj);
      } else {
        this.goToNextStage(obj);
      }
    }
    
    $('#empWaitModal').modal('hide');
  }
  
  empAdditionalEducationReconfirmSwipe(obj) {
    let direction = '_left';
    this.sliderIndex = 1;
    this.setSlider(this.sliderIndex, this.currentRow);
    this.currentSlideWithDirection = this.currentSlide + direction;
  }
  
  saveExit() {
    // PPA-8745 - Auto-generated via regex - Arun, Supreet, Save n Exit Patch
    var re = this._eventBus.logoutAnnounced({ dummy: "workflow_exit" });
    if (re == undefined) return;
  }
}
